import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/magazines/profile/loading';

export const Route = createFileRoute('/_private/settings/magazines/$id')({
  pendingComponent: Loading,
});
